import Profile from "./Profile";
import Demo from "./Demo";
import PricingDistribution from "./PricingDistribution";
import Launch from "./Launch";
import { Navigate } from "react-router";

export const serviceCreationRoutes = {
    DEFAULT_PAGE: {
        name: "default",
        path: "",
        element: <Navigate to="profile" replace />,
        index: true,
    },

    PROFILE: {
        name: "profile",
        path: "profile",
        element: <Profile />,
    },

    DEMO: {
        name: "demo",
        path: "demo",
        element: <Demo />,
    },

    PRICING_AND_DISTRIBUTION: {
        name: "pricinganddistribution",
        path: "pricing",
        element: <PricingDistribution />,
    },

    LAUNCH: {
        name: "launch",
        path: "launch",
        element: <Launch />,
    },
};

export const { PROFILE, DEMO, PRICING_AND_DISTRIBUTION, LAUNCH } = serviceCreationRoutes;
